export default "__VITE_ASSET__BhrDw_pV__"